import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "./AuthProvider.js";

export function ProtectedRoute({
  passwordChangeOnly = false
}: {
  passwordChangeOnly?: boolean;
}) {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === "loading") {
    return (
      <main className="foundation-status-page" aria-live="polite">
        <span className="foundation-spinner" aria-hidden="true" />
        <p>正在恢复安全会话…</p>
      </main>
    );
  }

  if (state.status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (state.user.mustChangePassword && !passwordChangeOnly) {
    return <Navigate to="/change-password" replace />;
  }

  if (!state.user.mustChangePassword && passwordChangeOnly) {
    return <Navigate to="/projects" replace />;
  }

  return <Outlet />;
}
